var _ellipse, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 211,
    viewBox: "0 0 207 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 107.744,
    rx: 26,
    ry: 26.4277,
    fill: "#ECF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 105.202C156.5 134.967 132.763 159.083 103.5 159.083C74.2366 159.083 50.5 134.967 50.5 105.202C50.5 75.4375 74.2366 51.3223 103.5 51.3223C132.763 51.3223 156.5 75.4375 156.5 105.202Z",
    stroke: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 105.204C181.5 149.003 146.571 184.495 103.5 184.495C60.4295 184.495 25.5 149.003 25.5 105.204C25.5 61.4044 60.4295 25.9121 103.5 25.9121C146.571 25.9121 181.5 61.4044 181.5 105.204Z",
    stroke: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 105.203C206.5 163.036 160.378 209.905 103.5 209.905C46.6223 209.905 0.5 163.036 0.5 105.203C0.5 47.3693 46.6223 0.5 103.5 0.5C160.378 0.5 206.5 47.3693 206.5 105.203Z",
    stroke: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.1 99.1211C97.6265 99.1211 94 102.748 94 107.221C94 111.695 97.6265 115.321 102.1 115.321C106.574 115.321 110.2 111.695 110.2 107.221C110.2 102.748 106.574 99.1211 102.1 99.1211Z",
    fill: "#3B6CCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.863 111.984C107.215 111.633 107.785 111.633 108.136 111.984L111.736 115.584C112.087 115.936 112.087 116.506 111.736 116.857C111.385 117.209 110.815 117.209 110.463 116.857L106.863 113.257C106.512 112.906 106.512 112.336 106.863 111.984Z",
    fill: "#3B6CCF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundRing);
export default __webpack_public_path__ + "static/media/round-ring.2fa2869e61b8acfd4b69d178c784715f.svg";
export { ForwardRef as ReactComponent };